
import documentReducer from 'features/documents/documentsSlice'
import categoryReducer from 'features/treeCategory/categorySlice'
import loginReducer from 'core/modules/auth/loginSlice'
import { combineReducers } from "redux";

export default combineReducers({
  user: loginReducer,
  category: categoryReducer,
  documents: documentReducer
})
